export default "__VITE_ASSET__BOhckmNf__"